import { render, staticRenderFns } from "./OneInfoShow.vue?vue&type=template&id=958ab9fc&"
import script from "./OneInfoShow.vue?vue&type=script&lang=js&"
export * from "./OneInfoShow.vue?vue&type=script&lang=js&"
import style0 from "./OneInfoShow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports